const firebaseApiKey =
  process.env.CHAMA_APP_FIREBASE_API_KEY || 'AIzaSyBWDZISIfHsZ-fNqfKV3szEThT_a3OmxJQ';
const firebaseAuthDomain =
  process.env.CHAMA_APP_FIREBASE_AUTH_DOMAIN || 'dl-master-dealertool.firebaseapp.com';
const firebaseDatabaseUrl =
  process.env.CHAMA_APP_FIREBASE_DATABASE_URL || 'https://dl-master-dealertool.firebaseio.com';
const sentryConfigUrl =
  process.env.CHAMA_APP_SENTRY_CONFIG_URL ||
  'https://a5540373b704455aaf0a7f3e40230477@sentry.io/1217650';
const apiHost = process.env.CHAMA_APP_API_HOST || 'dl-backoffice.chamapi.com/api';
const version = process.env.CHAMA_APP_VERSION || undefined;
const segmentApiKey = process.env.CHAMA_APP_SEGMENT_API_KEY || 'EocsAUcgiq96Eqy8YJENXdGgYwmQ30sW';
const splitioApiKey = process.env.CHAMA_APP_SPLIT_IO_API_KEY;
const newMdtHost = process.env.CHAMA_APP_NEW_MDT_HOST || 'https://dl-sdt.web.app';

const config = {
  version,
  api: {
    dt: {
      host: apiHost,
      timeout: 60 * 1000 * 5,
      fetchTicketsDelay: 2000,
    },
  },
  newMdtHost,
  sentry: {
    configUrl: sentryConfigUrl,
  },
  splitio: {
    apiKey: splitioApiKey,
  },
  appInsights: {
    instrumentationKey: '24d829ba-5039-45c7-9dbc-09e1223a6534',
  },
  firebase: {
    apiKey: firebaseApiKey,
    authDomain: firebaseAuthDomain,
    databaseURL: firebaseDatabaseUrl,
  },
  segment: {
    apiKey: segmentApiKey,
  },
  termsAndConditions: {
    actedVersion: '2017-09-04',
    versionLimitDate: '2017-09-25',
    segmentedLimitDate: '2017-09-18',
  },
};

// This needs to be ES5 syntax because the 'bump version' bin file
// uses this module to know when to bump major versions.
module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js